import { ComponentPropsWithoutRef, FC } from 'react';
import { Trans } from 'react-i18next';
import { Text } from '@components/Text/Text.component';
import { urlEnum } from '@utils/url';
import styles from './Footer.module.scss';

const Contact: FC<ComponentPropsWithoutRef<'div'>> = () => (
  <div className={styles['plc-footer-contact']}>
    <div className={`${styles['plc-by-mail']} plc-mb-m`}>
      <Text className="plc-mb-s" i18nKey="common.footer.by-post" tag="p" variant="h5" />
      <div>
        <Text variant="small">
          <Trans i18nKey="common.footer.address">
            <br />
          </Trans>
        </Text>
      </div>
    </div>
    <div className={`${styles['plc-by-post']} plc-mb-m`}>
      <Text className="plc-mb-s" i18nKey="common.footer.by-mail" tag="p" variant="h5" />
      <div>
        <Text variant="small">
          <Trans i18nKey="common.footer.via-contact-form">
            Via notre <a href={urlEnum.contactUs}>formulaire de contact</a>
          </Trans>
        </Text>
      </div>
    </div>
  </div>
);

export default Contact;
